import { Component } from '@verndale/core';
import Swiper, { Navigation } from 'swiper';
Swiper.use(Navigation);

class Module extends Component {
  setupDefaults() {
    this.dom = {
      $swiper: this.el._$('.swiper'),
      $swiperWrapper: this.el._$('.community-awards__swiper-wrapper'),
      $infoAwardContainer: this.el._$('.community-awards__info'),
      $images: Array.from(this.el.querySelectorAll('.community-awards__image')),
      $imagesContainer: Array.from(this.el.querySelectorAll('.community-awards__slider-image')),
      $paginationArrows: Array.from(this.el.querySelectorAll('.slider-pagination-row__arrow')),
      $awardHeadings: Array.from(this.el.querySelectorAll('.community-awards__slider-heading')),
      $awardCopy: Array.from(this.el.querySelectorAll('.community-awards__slider-copy')),
      $awardTitle: this.el._$('.community-awards__title'),
      $awardDescription: this.el._$('.community-awards__description'),
      $defaultTitle: this.el._$('.community-awards__title-default').innerHTML,
      $defaultCopy: this.el._$('.community-awards__description-default').innerHTML
    };
    this.awardInformationChange(0);
    if (this.dom.$images.length >= 2) {
      this.initSlider();
    } else {
      this.noSlider();
    }
  }

  noSlider() {
    this.dom.$paginationArrows.forEach(arrow => arrow.classList.add('arrow-close'));
    this.dom.$imagesContainer.forEach(images => images.classList.add('community-awards__slider-one-image'));
    this.dom.$swiperWrapper.classList.add('community-awards__swiper-wrapper-one-image');
    this.dom.$swiper.classList.remove('swiper');
  }

  awardInformationChange(index){
    if (this.dom.$awardHeadings[index].innerText === '' || this.dom.$awardHeadings[index].innerText === null) {
      this.dom.$awardTitle.innerHTML = this.dom.$defaultTitle
    } else {
      this.dom.$awardTitle.innerHTML = this.dom.$awardHeadings[index].innerText;
    }
    if (this.dom.$awardCopy[index].innerHTML === '' || this.dom.$awardCopy[index].innerHTML === null) {
      this.dom.$awardDescription.innerHTML = this.dom.$defaultCopy;
    } else {
      this.dom.$awardDescription.innerHTML = this.dom.$awardCopy[index].innerHTML;
    }
  }

  initSlider() {
    const swiperOptions = {
      autoHeight: false,
      slidesPerView: 1,
      slidesPerGroup: 1,
      centeredSlides:true,
      spaceBetween: 35,
      loop: true,
      breakpoints: {
        768: {
          slidesPerView: 3,
          slidesPerGroup: 1
        }
      },
      navigation: {
        nextEl: '.slider-pagination-row__arrow--next',
        prevEl: '.slider-pagination-row__arrow--prev',
        disabledClass: 'slider-pagination-disabled'
      }
    };

    if (this.dom.$images.length === 2){
      swiperOptions.breakpoints[768].slidesPerView = 2;
      swiperOptions.loop = false;
      this.dom.$imagesContainer.forEach(images => images.classList.add('community-awards__slider-two-images'));
      this.dom.$swiperWrapper.classList.add('community-awards__swiper-wrapper-two-images');
    }

    this.slider = new Swiper(this.dom.$swiper, swiperOptions);


    this.slider.on('slideChange', e => this.awardInformationChange(e.realIndex))
  }

}

export default Module;
